/* eslint-disable no-trailing-spaces */
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-membership-completion',
  templateUrl: './modal-membership-completion.component.html',
  styleUrls: ['./modal-membership-completion.component.scss']
})
export class ModalMembershipCompletionComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalMembershipCompletionComponent>) {
    
  }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
